import { animate, spring, stagger } from "motion";

export default {
  init: () => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return;
    }

    const shapes = document.querySelectorAll("[data-parallax-shape]");

    if (!shapes.length) {
      return;
    }

    shapes.forEach((shape) => {
      animate(shape, { y: ["50%", "0%"], opacity: [0, 1] }, { type: spring, stiffness: 50, damping: 20, duration: 1.5, delay: stagger(0.5) });
    });

    const handleScroll = () => {
      const scrollTop = document.documentElement.scrollTop;

      shapes.forEach((shape) => {
        const factor = shape.dataset.distance ?? 0.1;
        const translateY = scrollTop * parseFloat(factor) * -1;

        animate(shape, { y: translateY }, { type: spring, stiffness: 50, damping: 20, duration: 1.5, delay: stagger(0.5)});
      });
    };

    let ticking = false;

    window.addEventListener("scroll", () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    });

    handleScroll();
  },
};
